<div class="p-3">
  <div
    *ngIf="isShowClose"
    class="flex justify-content-between align-items-center">
    <p class="font-bold text-xl pl-3">Что изменилось?</p>
    <crm-button
      type="button"
      icon="pi pi-times"
      styleClass="p-button-rounded p-button-secondary p-button-text"
      (onClick)="ref?.close(data)"></crm-button>
  </div>

  <div
    class="px-3"
    style="padding-top: 1rem; padding-bottom: 1rem">
    <p
      class="quill-dynamic-styles block text-left"
      [innerHTML]="changelog?.text | safeHtml"></p>
    <div class="pt-3 hidden">
      <div class="col-fixed pl-0">
        <div class="field-checkbox mb-0">
          <p-checkbox
            [(ngModel)]="data.isRemoveModal"
            [binary]="true"
            inputId="byAll"></p-checkbox>
          <label [for]="'byAll'">Больше не показывать</label>
        </div>
      </div>
    </div>
  </div>
</div>
